module.exports = "/_next/static/images/8fe7f4745190c099b5d9708fcbf472b0-pj-man-holding-business-card@1x.jpg";